import React from 'react';
import { useLocation } from 'react-router-dom';
import { useHeroBackground } from '@/hooks/useHeroBackground';

interface HeroBackgroundWrapperProps {
  children: React.ReactNode;
}

export const HeroBackgroundWrapper: React.FC<HeroBackgroundWrapperProps> = ({ children }) => {
  const location = useLocation();
  const { settings, loading } = useHeroBackground();
  
  // Aplica o background em todas as páginas que usam o wrapper
  const shouldShowBackground = settings?.background_image_url && !loading;

  React.useEffect(() => {
    console.log('🌈 [HeroBackgroundWrapper] Should show background:', shouldShowBackground);
    console.log('🌈 [HeroBackgroundWrapper] Image URL:', settings?.background_image_url);
    console.log('🌈 [HeroBackgroundWrapper] Overlay opacity:', settings?.overlay_opacity);
    
    // Adiciona/remove classe no body para controlar o fundo
    if (shouldShowBackground) {
      document.body.classList.add('has-hero-background');
    } else {
      document.body.classList.remove('has-hero-background');
    }
    
    // Cleanup quando o componente for desmontado
    return () => {
      document.body.classList.remove('has-hero-background');
    };
  }, [shouldShowBackground, settings?.background_image_url, settings?.overlay_opacity]);

  return (
    <div style={{ position: 'relative', minHeight: '100vh' }}>
      {/* Background em todas as páginas que usam o wrapper */}
      {shouldShowBackground && (
        <>
          {/* Background Image Layer */}
          <div 
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100vw',
              height: '100vh',
              backgroundImage: `url(${settings.background_image_url})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center center',
              backgroundRepeat: 'no-repeat',
              zIndex: -100,
            }}
          />
          
          {/* Overlay Layer com Gradiente */}
          <div 
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100vw',
              height: '100vh',
              background: `linear-gradient(
                to bottom,
                rgba(0, 0, 0, ${settings.overlay_opacity}) 0%,
                rgba(0, 0, 0, ${settings.overlay_opacity}) 70%,
                rgba(0, 0, 0, 0.95) 100%
              )`,
              zIndex: -99,
            }}
          />
        </>
      )}
      
      {/* Conteúdo da página */}
      {children}
    </div>
  );
}; 